import React, { useCallback, useMemo, useState, useEffect, useContext } from "react";
import Dropdown, { OPTION_DISPLAY } from "@acadia-ui/dropdown";
import { ToolbarContext } from "@acadia-ui/toolbar";
import { shouldFilter } from "../utils";

export default function usePlatformDropdown({ isOpen, availablePlatforms, prefix }) {
	const context = useContext(ToolbarContext);
	const [value, setValue] = useState([]);

	const platformOptions = useMemo(() => {
		return availablePlatforms?.map(({ label, value }) => ({ label, value }));
	}, [availablePlatforms]);

	useEffect(() => {
		if (isOpen) {
			if (shouldFilter(`${prefix}-filter-platform-name`, context?.filterValues)) {
				setValue(
					Object.entries(context?.filterValues?.[`${prefix}-filter-platform-name`])
						?.filter(([_, value]) => value)
						?.map(([id]) => platformOptions?.find(({ value }) => value == id))
				);
			}
		} else {
			setValue([]);
		}
		// Intentionally exclude context from deps array as we only want to rerender when isOpen changes to true
	}, [isOpen, platformOptions, prefix]);

	const handleOnChange = useCallback((values) => {
		setValue(values);
	}, []);

	return useMemo(() => {
		return {
			element: (
				<Dropdown
					className={"gos-pm-filters-sidesheet-platform-dropdown"}
					multiple
					display={OPTION_DISPLAY.PILL_INLINE}
					value={value}
					options={platformOptions}
					placeholder={"Select a Platform"}
					onChange={handleOnChange}
					isClearable={true}
				>
					Activation Platform
				</Dropdown>
			),
			value,
			setValue
		};
	}, [platformOptions, value, handleOnChange]);
}
